import React from "react";
import { Checkbox, CheckboxGroup } from "react-checkbox-group";
import { Album as AlbumType } from "../types";
import ActiveIcon from "../vectors/ActiveIcon";
const album = require("../../styles/album.svg");

interface FilterByAlbumProps {
  albums: AlbumType[];
  selectedAlbums: [];
  updateFilter: Function;
  expanded: boolean;
  collapseFilter: Function;
  isActive: boolean;
  pageConfig: {
    accentColor: string;
  };
  trackFilterEvents: (filterType: string) => void;
}

class FilterByAlbum extends React.Component<FilterByAlbumProps> {
  constructor(props: FilterByAlbumProps) {
    super(props);
    this.selectionsChanged = this.selectionsChanged.bind(this);
  }

  selectionsChanged(newSelections: any) {
    this.props.updateFilter(newSelections);
    this.props.trackFilterEvents("album");
  }

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingThree">
          {this.props.isActive && (
            <div className="active-icon">
              <ActiveIcon color={this.props.pageConfig.accentColor} />
            </div>
          )}
          <img src={album} alt="" className="filter-icon" />
          <h4 className="panel-title">
            <a
              role="button"
              data-toggle="collapse"
              data-parent="#filter-accordion"
              href="#collapseThree"
              aria-controls="collapseThree"
              aria-expanded={this.props.expanded}
              className={`${this.props.expanded ? "" : "collapsed"}  ${
                this.props.isActive ? "active" : "inactive"
              }`}
              onClick={e => this.props.collapseFilter(e, "album")}
            >
              Album
            </a>
          </h4>
        </div>
        <div
          id="collapseThree"
          className={
            "panel-collapse collapse " + (this.props.expanded ? "in" : "")
          }
          role="tabpanel"
          aria-labelledby="headingThree"
        >
          <div className="panel-body">
            <ul className="check-radio checkmark">
              <CheckboxGroup
                name="selectedAlbums"
                value={this.props.selectedAlbums}
                onChange={this.selectionsChanged}
              >
                {this.props.albums.map(album => (
                  <li key={album.id}>
                    <label>
                      <Checkbox value={album.id} />
                      <span className="r-dot" />
                      <span className="r-desc">{album.name}</span>
                    </label>
                  </li>
                ))}
              </CheckboxGroup>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterByAlbum;
